import React, {useState} from 'react';
import Select from 'react-select';
import {Controller} from 'react-hook-form';
import classNames from 'classnames';
import {DirectionService} from "../../../../../api/directionService";
import classes from "../../../Forms/RegistrationForm/DirectionForm/form.module.scss";
import {log} from "qrcode/lib/core/galois-field";

const EditableField = ({
    el,
    errors,
    register,
    control,
    classes,
}) => {
    const [searchedDoctors, setSearchedDoctors] = useState([])
    const [showSuggestions, setShowSuggestions] = useState(false);

    const findByParamsHandler = async(e) => {
        await DirectionService.getDirectionDataByParam(e).then(res => {
            if (res?.data){
                setSearchedDoctors(res?.data)
            }
        })
    }

    // Если поле не редактируемое — просто показываем value в readOnly режиме
    if (!el?.canBeEdited){
        if (el?.value && el?.name !== 'gender' && el?.name !== 'antibodies'){
            return (
                <>
                    <label htmlFor={el.name}>{el.label}</label>
                    <input
                        className={classNames(classes.form__input)}
                        type={el.type}
                        value={el.value || ''}
                        readOnly
                        disabled
                    />
                </>
            );
        }

        if (el?.name === 'antibodies'){
            return (
                <>
                    <label htmlFor={el.name}>{el.label}</label>
                    <textarea
                        className={classNames(classes.form__input)}
                        value={el.value || ''}
                        readOnly
                        disabled
                    />
                </>
            );
        }

        return null;
    }


    // Если редактируемое — используем defaultValue и регистрируем input
    if (
        el?.value &&
        !['gender', 'biopsy', 'antibodies', 'activeDoc', 'markedMaterial', 'departmentId', 'externalDepartmentId', 'contractId'].includes(el?.name)
    ) {
        return (
            <>
                <label htmlFor={el.name}>{el.label}</label>
                <input
                    className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                    type={el.type}
                    defaultValue={el.value || ''}
                    {...register(el.name)}
                />
            </>
        );
    }

    if (el?.name === 'birthDate') {
        return (
            <>
                {el.props.map((props) => (
                    <input
                        key={props.id}
                        className={classNames(
                            classes.form__input,
                            { [classes.errorInput]: errors[props.name] }
                        )}
                        style={{ width: '50px' }}
                        type="number"
                        max={props.max}
                        placeholder={props.placeholder}
                        disabled={props.show}
                        defaultValue={props.defaultValue}
                        {...register(props.name, {
                            required: false,
                            max: props.max,
                            valueAsNumber: true
                        })}
                        onInput={(e) => {
                            const value = Number(e.target.value);
                            if (value > props.max) e.target.value = props.max;
                        }}
                    />
                ))}
            </>
        );
    }

    if (el?.name === 'biopsy'){
        return (
            <>
                {el?.props?.map((props, i) => (
                    <div className={classes.form__label__container__box} key={'a' + i}>
                        <label>{props.label}</label>
                        <input
                            className={classNames(classes.form__input, {
                                [classes.errorInput]: errors[el.name],
                            })}
                            type="radio"
                            value={props.label}
                            defaultChecked={props.label === el.value}
                            {...register(el.name, {
                                required: "Поле обов'язкове для заповнення",
                            })}
                        />
                    </div>
                ))}
            </>
        )
    }

    if (el?.value && (el?.name === 'gender' || el?.name === 'markedMaterial')){
        return (
            <Controller
                control={control}
                name={el?.name}
                rules={{required: "Оберіть одне значення"}}
                defaultValue={el.value}
                render={({field: {onChange, value}, fieldState: {error}}) => (
                    <Select
                        className={classNames(classes.select, {[classes.errorInput]: error})}
                        options={el.props}
                        defaultValue={el.props.find(option => option.value === el.value)}
                        onChange={(selectedOption) => onChange(selectedOption.value)}
                        placeholder="Оберіть значення..."
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.id}
                    />
                )}
            />
        );
    }

    if (el.value && el.name === 'activeDoc'){
        return (
            <Controller
                control={control}
                name={el.name}
                className={classes.select}
                render={({field: {onChange, value}, fieldState: {error}}) => {

                    const handleInputChange = (e) => {
                        const inputValue = e.target.value;
                        onChange(inputValue);
                        if (el.name === 'activeDoc'){
                            findByParamsHandler(inputValue);
                            setShowSuggestions(true);
                        }
                    };

                    const handleOptionClick = (option) => {
                        onChange(option);
                        setShowSuggestions(false);
                    };

                    return (
                        <div className={classes.inputWrapper}>
                            <input
                                className={classNames(classes.form__input, {
                                    [classes.errorInput]: error,
                                })}
                                type="text"
                                value={value || el.value}
                                onChange={handleInputChange}
                                placeholder="Введіть значення..."
                                autoComplete="off"
                                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                onFocus={() => setShowSuggestions(true)}
                            />

                            {el.name === 'activeDoc' && searchedDoctors?.length > 0 && showSuggestions && (
                                <ul className={classes.suggestionsList}>
                                    {searchedDoctors
                                        .filter((option) => option !== value)
                                        .map((option, idx) => (
                                            <li
                                                key={idx}
                                                className={classes.suggestionItem}
                                                onClick={() => handleOptionClick(option)}
                                            >
                                                {option}
                                            </li>
                                        ))}
                                </ul>
                            )}
                        </div>
                    );
                }}
            />
        )
    }


    if (el.options || el.props){
        return (
            <Controller
                control={control}
                name={el.name}
                render={({field: {onChange, value}}) => (
                    <Select
                        className={classes.select}
                        options={el.props}
                        defaultValue={
                            el?.name === 'antibodies'
                                ? el?.props?.filter(option =>
                                    el.value?.some(val => val.id === option.id)
                                )
                                : el?.props.find(option => {
                                return option.value === el.value
                            }) || null
                        }
                        onChange={selectedOption => {
                            if (el.name === 'antibodies'){
                                const newValue = selectedOption.map(option =>
                                    ['departmentId','externalDepartmentId', 'antibodies'].includes(el.name) ? option.id : option.value
                                );
                                onChange(newValue);
                            } else {
                                const newValue = selectedOption.id;
                                onChange(newValue);
                            }
                        }}
                        isMulti={el.name === 'antibodies'}
                        disableSearch
                        hasSelectAll={false}
                        placeholder="Виберіть значення..."
                        getOptionLabel={option => option.label}
                        getOptionValue={option => option.id}
                    />
                )}
            />
        );
    }


    return null;
};

export default EditableField;
